import * as XLSX from 'xlsx';

/**
 * Common utility to export data to Excel (.xlsx)
 * @param {Array} data - Array of objects containing row data
 * @param {string} fileName - Name of the file to be saved
 * @param {string} sheetName - Name of the worksheet tab
 */
export const exportToExcel = (data, fileName = 'Report.xlsx', sheetName = 'Revenue Data') => {
  // Create a new workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Buffer and download the file
  XLSX.writeFile(workbook, fileName);
};